<template>
  <div>
    <div v-for="(rows, indexRow) in formattedValues" :key="`row-${indexRow}`" :class="indexRow === 0 ? 'mt-10' : ''" class="wrapper-legends">
      <div v-for="(value, indexCol) in rows" :key="`col-${indexCol}`" class="pa-2">
        <v-row>
          <v-col class="py-0" cols="6">
            <img width="80px" height="25px" :src="value.image" />
          </v-col>
          <v-col class="py-0 pl-0" cols="6">
            <h5 class="mb-0 range-text" :style="{ color: value.color }">FAIXA {{ indexRow >= 1 ? indexCol + 6 : indexCol + 1 }}</h5>
          </v-col>
          <v-col class="pt-1 pb-0" cols="12">
            <p class="mb-0 texto-corrido">{{ value.minimumValue | localeString(2) | currency }} - {{ value.maximumValue | localeString(2) | currency }}</p>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PriceRangeValues',
  props: {
    adjustValue: {
      type: Function,
      required: true,
    },
    values: {
      type: Array,
      required: true,
    },
    colors: {
      type: Array,
      required: true,
    },
  },
  computed: {
    formattedValues() {
      const imagesArray = [
        require('@/assets/price-range/jardim-botanico.png'),
        require('@/assets/price-range/museu.png'),
        require('@/assets/price-range/cristo.png'),
        require('@/assets/price-range/pao-de-acucar.png'),
        require('@/assets/price-range/copacabana.png'),
        require('@/assets/price-range/faixa.png'),
        require('@/assets/price-range/ponto1.png'),
        require('@/assets/price-range/catedral.png'),
        require('@/assets/price-range/ponto2.png'),
        require('@/assets/price-range/elevador-lacerda.png'),
      ]

      return this.values.reduce(
        (accumulator, value, index) => {
          const previousValue = this.adjustValue(this.values[index - 1])
          const formattedValue = {
            minimumValue: previousValue,
            maximumValue: value,
            color: this.colors[index],
            image: imagesArray[index],
          }

          if (index < 5) {
            accumulator[0].push(formattedValue)
          } else {
            accumulator[1].push(formattedValue)
          }
          return accumulator
        },
        [[], []]
      )
    },
  },
}
</script>

<style lang="scss">
.range-text {
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 16px;
}
.wrapper-legends {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}
.vue-slider-dot {
  z-index: 1 !important;
}
</style>
